import { render, staticRenderFns } from "./FieldText.colourIcon.vue?vue&type=template&id=10a81796&"
import script from "./FieldText.colourIcon.vue?vue&type=script&lang=js&"
export * from "./FieldText.colourIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports